import React from 'react'
import cn from 'classnames'
import styles from './NewPastImages.module.scss'
import PreviewImage from '../../PreviewImage'

export default function PastImage({ studentImage, backgroundUrl, selectedImages, toggleImage }) {
  const isSelected = selectedImages.map((image) => image.id).includes(studentImage.id)
  return (
    <div
      role="button"
      className={cn(
        styles.child,
        {
          [styles.selected]: isSelected,
        },
      )}
      onClick={() => toggleImage(studentImage)}
    >
      {isSelected && (
        <div className={styles.checked}>
          <p>Added</p>
        </div>
      )}
      <div className={styles.shadowContainer}>
        <PreviewImage
          foregroundUrl={studentImage.imageUrl}
          backgroundUrl={backgroundUrl}
        />
      </div>
    </div>
  )
}
